import { selector } from 'recoil';
import { businessFlowSelector } from './getBusinessFlowSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const hideInfoInMpsSelector = selector({
    key: 'hideInfoInMpsSelector',
    get: ({ get }) => {
        const isMps = get(businessFlowSelector) === 'MPS';
        const { isSubmission } = get(jobInfoAtom);
        return isMps && !isSubmission;
    }
});
